import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MsgConfig } from 'src/app/app.messages';
import { PharmacyLabels } from 'src/app/models/labels.models';
import { CommonService } from 'src/app/services';
import { FormatsUtil } from 'src/app/utils/formats.util';
import { PatientInfoUtil } from 'src/app/utils/patient-info.util';

@Component({
  selector: 'app-current-pharmacy',
  templateUrl: './current-pharmacy.component.html',
  styleUrls: ['./current-pharmacy.component.scss']
})
export class CurrentPharmacyComponent implements OnInit {
  requestPharmacyDetails: any  = {
  };
  pharmacistName: string = "";
  msgConfig;
  pharmacyabels: any;
  @Input() LabelName:string;
  @Input() IsFromRequestInfo:string;
  @Input() IsfromExpand:boolean;
  @Output() RequestPharmacyDetails = new EventEmitter();
  constructor(private _commonServ:CommonService, 
              private _formatUtil:FormatsUtil,
              private _patientUtil: PatientInfoUtil) { }
  ngOnInit(): void {
    this.msgConfig = MsgConfig;
      this.getRequestPharmacy();
      this.pharmacyabels = new PharmacyLabels();
      this.pharmacistName = this._commonServ.DecryptData(localStorage.getItem("PharmacistName"));
  }
  async getRequestPharmacy() {
    const tenantDetails = this._commonServ.newTenatInfo$["source"]["value"];
    if (tenantDetails?.PharmacyDetails) {
      tenantDetails.PharmacyDetails.TelephoneNumber = this._formatUtil.getPhoneFormat(tenantDetails.PharmacyDetails.Telephone);
      tenantDetails.PharmacyDetails.pharmAddress = this._patientUtil.getPatientAddress({
        address1: tenantDetails.PharmacyDetails.AddressLine1,
        address2: tenantDetails.PharmacyDetails.AddressLine2,
        state: tenantDetails.PharmacyDetails.StateName,
        zipcode: tenantDetails.PharmacyDetails.ZipCode,
        city: tenantDetails.PharmacyDetails.CityName,
      });
    }
    this.requestPharmacyDetails = tenantDetails.PharmacyDetails;
    if (tenantDetails?.Faxdetails?.Fax) {
      this.requestPharmacyDetails['fax'] = this._formatUtil.getPhoneFormatForWrongFax(
        tenantDetails.Faxdetails.Fax
      );
    }
  }
}
